import { render } from "./WarehouseDetail.vue?vue&type=template&id=57f129ae&scoped=true"
import script from "./WarehouseDetail.vue?vue&type=script&lang=js"
export * from "./WarehouseDetail.vue?vue&type=script&lang=js"

import "./WarehouseDetail.vue?vue&type=style&index=0&id=57f129ae&scoped=true&lang=css"

import exportComponent from "/home/cm/project/golinker/admin-panel/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-57f129ae"]])

export default __exports__